import { PERMISSIONS } from '@conversed/shared/src/central/constants/permissions';
import { LLMBlockWithMetadataSchema } from '@conversed/shared/src/central/types/blocks/LLMBlock';
import { StudioType } from '@conversed/shared/src/central/types/studio.type';
import { z } from 'zod';
import { createRESTContract } from '../../index';
import { BlockSchema } from './flow.schema';

const { FLOW } = PERMISSIONS;

export const StudioLLMBlockSchema = z.object({
  blockId: z.string(),
  metadataId: z.string(),
  label: z.string(),
  botName: z.string(),
  companyId: z.string(),
  studioType: z.enum(
    Object.values(StudioType) as [StudioType, ...StudioType[]],
  ),
  studioName: z.string(),
  dataSources: z.array(z.string()),
});

export type TStudioLLMBlock = z.infer<typeof StudioLLMBlockSchema>;

export const flowContract = createRESTContract({
  getFlow: {
    method: 'GET',
    path: '/flow',
    permissions: [FLOW.FLOW_LIST],
    response: z.array(BlockSchema),
  },
  getFlowEntryPoints: {
    method: 'GET',
    path: '/flow/entries',
    permissions: [FLOW.FLOW_LIST],
    response: z.array(z.string()),
  },
  updateFlow: {
    method: 'POST',
    path: '/flow',
    permissions: [FLOW.FLOW_EDIT],
    body: z.object({
      created: z.array(BlockSchema),
      updated: z.array(BlockSchema),
      deleted: z.array(z.string()),
    }),
    response: z.void(),
  },
  getLLMBlocks: {
    method: 'GET',
    path: '/flow/llm-blocks',
    permissions: [FLOW.FLOW_LIST],
    response: LLMBlockWithMetadataSchema.array(),
  },
  getLLMBlocksByCompany: {
    method: 'GET',
    path: '/flow/llm-blocks-by-company',
    permissions: [FLOW.FLOW_LIST],
    response: z.array(StudioLLMBlockSchema),
  },
});
